import { useEffect, useState } from "react";
import { EmployeeRecord, EmployeeReferenceType } from "winslow-core";
import { apiGetEmployeeRecordsForWorkspace } from "../../../services/EmployeeRecordService";
import { selectUIStates, selectUser, setUIStates } from "../../../redux/features/appData/appDataSlice";
import { useDispatch, useSelector } from "react-redux";
import { erGetCPValue } from "../app-employee-records/employeeRecordUtils";
import { Icon } from "lucide-react";
import { openEmployeeProfileSidebar } from "../../../redux/features/agent/agentSlice";

type AppDirectoryProps = {

}

export const AppDirectory = ({} : AppDirectoryProps) => {

    const storeUser = useSelector(selectUser);
    const uiStates = useSelector(selectUIStates);

    const dispatch = useDispatch();

    const [employeeRecords, setEmployeeRecords] = useState<EmployeeRecord[]>([]);


    useEffect(() => {
        dispatch(setUIStates({...uiStates, hrisLocation: "Company Directory"}));
    }, []);

    useEffect(() => {
        (async () => {
            if (storeUser?.currentWorkspaceId) {
                const records = await apiGetEmployeeRecordsForWorkspace(storeUser.currentWorkspaceId);
                setEmployeeRecords(records || []);
            }
        })();
    }, []);

    const handleViewEmployeeRecord = (er: EmployeeRecord) => {
        dispatch(openEmployeeProfileSidebar({
            employeeId: er.id,
            type: EmployeeReferenceType.EMPLOYEE_RECORD
        }));
    }

    const activeEmployeeRecords = employeeRecords.filter((er: EmployeeRecord) => er.active);

    return (
        <div className="app-employee-records">
            {/* <div className="app-employee-records-tabs">
                <div 
                    className={tab === TABS.EMPLOYEES ? 
                        "app-employee-records-tab-selected" : "app-employee-records-tab"
                    }
                    onClick={() => setTab(TABS.EMPLOYEES)}
                >
                    <Users size={16} />
                    <span>Employees</span>
                </div>
                <div 
                    className={tab === TABS.CONTRACTORS ? 
                        "app-employee-records-tab-selected" : "app-employee-records-tab"
                    }
                    onClick={() => setTab(TABS.CONTRACTORS)}
                >
                    <Briefcase size={16} />
                    <span>Contractors</span>
                </div>
                <div 
                    className={tab === TABS.VENDORS ? 
                        "app-employee-records-tab-selected" : "app-employee-records-tab"
                    }
                    onClick={() => setTab(TABS.VENDORS)}
                >
                    <Building size={16} />
                    <span>Vendors</span>
                </div>
                <div className="app-employee-records-tab-actions">
                    <ActionLink
                        label="Add Employee"
                        leftIcon={<UserPlus size={16} />}
                        onClick={() => {
                            navigate("/app/employee-records/new");
                        }}
                    />

                    
                    
                </div>
                
            </div> 
            */}

            {activeEmployeeRecords && activeEmployeeRecords.length > 0 &&
                <>
                    <div className="app-employee-records-table-container">
                        <table className="app-employee-records-table">
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Title</th>
                                    <th>Manager</th>
                                    <th>Phone</th>
                                    <th>Email</th>
                                </tr>
                            </thead>
                            <tbody>
                                {activeEmployeeRecords.map((er: EmployeeRecord) => (
                                    <tr key={er.id} className="app-employee-records-row">
                                        <td className="app-employee-records-name-cell">
                                            <div 
                                                className="app-employee-records-name-content app-employee-records-name-clickable"
                                                onClick={() => handleViewEmployeeRecord(er)}
                                            >
                                                <div className="app-employee-records-avatar">
                                                    {er.avatarURL ? (
                                                        <img 
                                                            src={er.avatarURL} 
                                                            alt={`${erGetCPValue(er, "system-firstName")} ${erGetCPValue(er, "system-lastName")}`}
                                                            className="app-employee-records-avatar-img"
                                                        />
                                                    ) : (
                                                        <div className="app-employee-records-avatar-placeholder">
                                                            {erGetCPValue(er, "system-firstName")?.charAt(0) || ''}{erGetCPValue(er, "system-lastName")?.charAt(0) || ''}
                                                        </div>
                                                    )}
                                                </div>
                                                <strong>{erGetCPValue(er, "system-firstName")} {erGetCPValue(er, "system-lastName")}</strong>
                                            </div>
                                        </td>
                                        <td className="app-employee-records-title-cell">
                                            {erGetCPValue(er, "system-title") || '-'}
                                        </td>
                                        <td className="app-employee-records-manager-cell">
                                            {(() => {
                                                const managerId = erGetCPValue(er, "system-managerId");
                                                if (!managerId) {
                                                    return <span>-</span>;
                                                }
                                                const manager = employeeRecords.find(m => m.id === managerId);
                                                if (!manager) {
                                                    return <span>-</span>;
                                                }
                                                const managerFirstName = erGetCPValue(manager, "system-firstName") || '';
                                                const managerLastName = erGetCPValue(manager, "system-lastName") || '';
                                                const managerName = `${managerFirstName} ${managerLastName}`.trim();
                                                return (
                                                    <div 
                                                        className="app-employee-records-name-content app-employee-records-name-clickable"
                                                        onClick={() => handleViewEmployeeRecord(manager)}
                                                    >
                                                        <div className="app-employee-records-avatar">
                                                            {manager.avatarURL ? (
                                                                <img 
                                                                    src={manager.avatarURL} 
                                                                    alt={managerName}
                                                                    className="app-employee-records-avatar-img"
                                                                />
                                                            ) : (
                                                                <div className="app-employee-records-avatar-placeholder">
                                                                    {managerFirstName?.charAt(0) || ''}{managerLastName?.charAt(0) || ''}
                                                                </div>
                                                            )}
                                                        </div>
                                                        <strong>{managerName || '-'}</strong>
                                                    </div>
                                                );
                                            })()}
                                        </td>
                                        <td className="app-employee-records-phone-cell">
                                            {erGetCPValue(er, "system-workPhone") || '-'}
                                        </td>
                                        <td className="app-employee-records-email-cell">
                                            {er.workEmail}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </>
            }

        </div>
    )
}